<template>
  <button
    class="w-36 px-3 py-1 bg-purple-600 rounded shadow text-center text-white hover:shadow-lg hover:bg-purple-500 transition duration-200 ease-in-out"
  >
    <slot></slot>
  </button>
</template>